import React, { useState } from 'react'
import classnames from 'classnames'
import { useRouter } from 'next/router'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import buildUrl from 'Pages/auto/home/utils'
import PriceInput from './price-input'
import { ContextStore } from './reducer'
import { IConditionsProps, ISortProps } from './interface'
import SeriesType from './series-type'
import Other from './other'
import FuelForm from './fuel-form'

interface IProps {
  conditions: IConditionsProps[]
  /* 展示更多条件下面的线 */
  hideline?: boolean
  foldprops: boolean
}

export default function Conditions({
  conditions,
  hideline,
  foldprops,
}: IProps) {
  const router = useRouter()
  // 是否展开条件
  const [fold, setFold] = useState(foldprops)
  /* 判断是否是条件的请求 */
  // const { dispatch } = React.useContext(ContextStore)
  const { state, dispatch } = React.useContext(ContextStore)

  const renderControlFold = () => {
    return (
      <div className={classnames({ line: !hideline })}>
        <span
          role="button"
          className={'button-wrap'}
          onClick={() => {
            setFold(!fold)
            sendTeaCommEvent('clk_event', {
              event_id: 'car_select_more',
              shrink_type: !fold ? 'unfold' : 'fold',
            })
          }}
        >
          {fold ? '收起 ' : '更多条件(结构/排量/配置)'}
          <span className="arrow-down" />
        </span>
        <style jsx>
          {`
            div {
              margin: 0 20px;
              text-align: center;
            }
            div:hover {
              color: #406599;
            }
            .button-wrap {
              height: 56px;
              line-height: 56px;
              cursor: pointer;
              color: #606370;
              font-size: 14px;
              transition: color 0.2s ease-in-out;
            }
            .button-wrap:hover {
              color: #E62021;
            }
            .button-wrap{
              position: relative;
            }
            .button-wrap:hover .arrow-down{
              border-top: 5px solid #e62021;
            }
            .arrow-down{
                position: absolute;
                width: 0;
                height: 0;
                margin-left: 2px;
                top: 7px;
                border-right: 4px solid transparent;
                border-left: 4px solid transparent;
                border-top: 5px solid #606370;
                transform: rotate(${fold ? '-180deg' : '0deg'});
              }
          `}
        </style>
      </div>
    )
  }
  const getStat = (options: any) => {
    return Object.keys(options).reduce((acc: any, curr: string) => {
      acc[curr] = options[curr].map((item: any) => item.param).join(',')
      return acc
    }, {})
  }

  const allConditionKeys = React.useMemo(() => {
    return conditions.map(item => {
      return Array.from(
        new Set(item.data.map(item => item.key).filter(item => !!item))
      )
    })
  }, [conditions])

  // 单选相关的埋点
  const sendTea = (item: ISortProps) => {
    const params: {
      [key: string]: string
    } = {}

    switch (item.key) {
      case 'price':
        params.event_id = 'car_select_price'
        params.price_range = item.text
        break
      case 'series_type':
      case 'outter_detail_type':
        params.event_id = 'car_select_style_category'
        params.car_style_category_name = item.text
        break
      case 'dcar_score':
        params.event_id = 'car_select_dscore'
        params.dscore_range = item.text
        break
      case 'fuel_form':
        params.event_id = 'car_select_energy_category'
        params.car_energy_category_name = item.text === '全部' ? '新能源' : item.text
        break
      case 'country':
        params.event_id = 'car_select_national_category'
        params.car_national_category_name = item.text
        break
      case 'body_detail_type':
        params.event_id = 'car_select_struct_category'
        params.car_struct_category = item.text
        break
      case 'seat_count':
        params.event_id = 'car_select_seats'
        params.seat_count_range = item.text
        break
      case 'gearbox_type':
        params.event_id = 'car_select_other_category'
        params.car_category_name = '变速箱'
        params.car_category_value = item.text
        break
      case 'capacity_l':
        params.event_id = 'car_select_other_category'
        params.car_category_name = '排量'
        params.car_category_value = item.text
        break
      case 'cylinder_nums':
        params.event_id = 'car_select_other_category'
        params.car_category_name = '气缸数'
        params.car_category_value = item.text
        break
      case 'driven_form':
        params.event_id = 'car_select_other_category'
        params.car_category_name = '驱动方式'
        params.car_category_value = item.text
        break
      case 'gas_form':
        params.event_id = 'car_select_other_category'
        params.car_category_name = '进气方式'
        params.car_category_value = item.text
        break
    }
    sendTeaCommEvent('clk_event', params)
  }

  const handleOptionClick = (item: ISortProps, line: number, clearLine?: number) => {
    const copyItem = Object.assign({}, item)
    // 是否为已经选择的，需要转为不限
    if (copyItem?.key &&
      state?.[copyItem?.key]?.[0] &&
      copyItem?.param === state?.[copyItem?.key]?.[0]?.['param']) {
      copyItem.text = '不限'
      copyItem.param = 'x'
    }
    sendTea(copyItem)
    // 第N行条件
    const currentLine = allConditionKeys[line]
    // dispatch({ type: 'conditions' })
    const newOptions = Object.assign({}, state)

    if (clearLine !== undefined) {
      // 可以指定清空特定行
      const clearLineItem = allConditionKeys[clearLine]
      clearLineItem.forEach(key => {
        newOptions[key] = []
      })
    }

    // 选择不限时，清空整行元素
    if (copyItem.text.indexOf('不限') >= 0) {
      currentLine.forEach(key => {
        newOptions[key] = []
      })
      router.push(
        `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
        }`,
        `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
        }`
      )

      return
    }
    // 初始值为空
    if (!newOptions[copyItem.key]) {
      newOptions[copyItem.key] = []
    }

    newOptions[copyItem.key] = [
      {
        text: copyItem.text,
        param: copyItem.param,
      },
    ]
    router.push(
      `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
      }`,
      `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
      }`
    )
  }

  function isOptionActive(option: ISortProps, line: number): boolean {
    if (!option) {
      return false
    }
    // 不限的高亮条件：同一行中没有被选中的元素
    if (option.text === '不限') {
      return !allConditionKeys[line].some(
        item => !!state[item] && state[item].length > 0
      )
    }
    if (!state[option.key] || !state[option.key].length) {
      return false
    }
    // ===部分条件筛选有问题
    if (state[option.key].some(item => item.param == option.param)) {
      return true
    }
    return false
  }

  const topArr = [
    0, // 价格
    1, // 级别
    11, // 懂车分
    6, // 能源
  ]; // index 为 condition的排序

  const secArr = [
    2, // 国别
    4, // 结构
    7, // 座位数
  ]; // index 为 condition的排序

  function renderList(sortArr: any[]) {
    return (
      <>
        {
          sortArr.map((line: number) => {
            const data: IConditionsProps = conditions[line];
            if (data.template === 'single') {
              return (
                <div className="item-wrap clearfix" key={data.title}>
                  <span className="name">{data.title}</span>
                  <div className="item-list">
                    {data.data.map((item: ISortProps) => {
                      if (item.text === '输入框') {
                        return (
                          <div className="condition-input" key={item.text}>
                            <PriceInput
                              key={item.text}
                              onClick={handleOptionClick}
                              price={state[item.key]}
                              type={item.key}
                              typeText={item.key === 'dcar_score' ? '分' : '万'}
                              line={line}
                            />
                          </div>
                        )
                      }
                      return (
                        <span
                          key={item.text}
                          role="button"
                          className={classnames('item-child big-mr condition', {
                            active: isOptionActive(item, line),
                          })}
                          onClick={event => {
                            event.stopPropagation()
                            handleOptionClick(item, line)
                          }}
                        >
                          {item.text}
                        </span>
                      )
                    })}
                  </div>
                </div>
              )
            }

            if (data.template === 'car') {
              return (
                <SeriesType key={data.title}
                  handleOptionClick={handleOptionClick}
                  isOptionActive={isOptionActive} />
              )
            }

            if (data.template === 'fuel_form') {
              return (
                <FuelForm key={data.title}
                  handleOptionClick={handleOptionClick}
                  isOptionActive={isOptionActive} />
              )
            }
          })
        }
        <style jsx>
          {`
          .condition-input {
            display: inline-block;
            margin-top: 12px;
          }
          `}
        </style>
      </>
    )
  }

  return (
    <React.Fragment>
      {renderList(topArr)}
      <section
        className={`${!fold ? 'fold tw-h-0 xl:tw-h-60' : ''}`}>
        {renderList(secArr)}
        <Other key={'other'}
          handleOptionClick={handleOptionClick}
          isOptionActive={isOptionActive} />
      </section>
      {renderControlFold()}
      <style jsx>
        {`
          h2 {
            line-height: 60px;
            margin: 0 20px;
            font-size: 24px;
            font-weight: 500;
            box-shadow: 0 1px 0 0 #ededed;
          }
          .fold {
            overflow: hidden;
          }
          .active {
            background-color: #ffe100;
          }
          .active:hover {
            color: #1a1a1a;
            background-color: #ffe100;
          }
        `}
      </style>
    </React.Fragment>
  )
}
